/**
 * Mensaje legible y localizado de un error de API.
 *
 * El backend responde `{"error": {"code", "message", "details"}}`: se traduce el `code`
 * con el namespace `errors` y, si no hay traducción, se usa el `message` que
 * ya viene localizado por `Accept-Language`.
 */

import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { ApiError } from '../api/client'

export function useApiErrorMessage(): (error: unknown) => string {
  const { t, i18n } = useTranslation('errors')
  return useCallback(
    (error: unknown) => {
      if (error instanceof ApiError) {
        const fallback = error.body?.message ?? error.message
        // `details` lleva los params del mensaje (p.ej. `template_key`).
        return i18n.exists(`errors:${error.code}`)
          ? t(error.code, error.body?.details ?? {})
          : fallback
      }
      return error instanceof Error ? error.message : String(error)
    },
    [t, i18n],
  )
}
